export default "__VITE_ASSET__CC1J1JSZ__"